import { render, staticRenderFns } from "./CustomerInvoiceDetail.vue?vue&type=template&id=4b044e7c"
import script from "./CustomerInvoiceDetail.vue?vue&type=script&lang=js"
export * from "./CustomerInvoiceDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports